export default class NumberFormatUtil {
  public static currency = (num: number): string => {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    });
    return formatter.format(num);
  }
}
